import { render, staticRenderFns } from "./placeInput.vue?vue&type=template&id=13bfbbee"
import script from "./placeInputImpl.js?vue&type=script&lang=js&external"
export * from "./placeInputImpl.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports